import LocalImages from "assets/images/local-images";
import Content, { ContentNS } from "content/content";
import OutlinedButton from "features/shared/components/buttons/OutlinedButton.styled";
import PrimaryButton from "features/shared/components/buttons/PrimaryButton.styled";
import useNavigateBackInfo, {
  PageType,
} from "features/shared/hooks/navigation/useNavigateBackInfo";
import useNavigateWithQuery from "features/shared/hooks/navigation/useNavigateWithQuery";
import useMultiPaxSession from "features/shared/hooks/useMultiPaxSession";
import { FC } from "react";
import NativeBridge from "services/native-bridge/native-bridge";
import { useAppStore } from "store/store";

import PaxErrorButtons from "./styles/PaxErrorButtons.styled";
import PaxErrorContainer from "./styles/PaxErrorContainer.styled";
import PaxErrorMessage from "./styles/PaxErrorMessage.styled";

interface PaxErrorProps {
  errorDescription: string;
  hasEditSettingsButton?: boolean;
  hasReturnToBookingButton?: boolean;
}

const PaxError: FC<PaxErrorProps> = ({
  errorDescription,
  hasEditSettingsButton,
  hasReturnToBookingButton,
}) => {
  const navigate = useNavigateWithQuery();

  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.checklist });
  const isMultiPax = useMultiPaxSession();

  const returnUrl = useAppStore((state) => state.returnUrl);

  const backLinkInfo = useNavigateBackInfo(PageType.Checklist);

  const handleReturnToBooking = () => {
    if (NativeBridge.shared.isEmbedded) {
      NativeBridge.shared.closeFlow("ineligible");
    } else if (returnUrl) {
      window.open(returnUrl, "_blank");
    }
  };

  return (
    <PaxErrorContainer>
      <img
        alt="passenger error"
        src={LocalImages.shared.images.icons.paxError}
      />
      <PaxErrorMessage>{errorDescription}</PaxErrorMessage>
      <PaxErrorButtons>
        {isMultiPax ? (
          <PrimaryButton onClick={() => navigate("../select-passenger")}>
            {text("pax-error-button.see-all-passengers")}
          </PrimaryButton>
        ) : null}

        {hasEditSettingsButton ? (
          <PrimaryButton
            onClick={() => {
              if (!backLinkInfo) {
                // there is no back link - use default
                navigate("../questions", {
                  state: { isEditing: true },
                });
                return;
              }

              // there is back link
              navigate(backLinkInfo.to, {
                state: backLinkInfo.state,
              });
            }}
          >
            {text("pax-error-button.edit-settings")}
          </PrimaryButton>
        ) : null}

        {hasReturnToBookingButton &&
        (returnUrl !== null || NativeBridge.shared.isEmbedded) ? (
          <OutlinedButton onClick={handleReturnToBooking}>
            {text("pax-error-button.return-to-booking")}
          </OutlinedButton>
        ) : null}
      </PaxErrorButtons>
    </PaxErrorContainer>
  );
};

export default PaxError;
